import React, { PureComponent } from 'react';

import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

const Right = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            // eslint-disable-next-line react/no-unused-prop-types
            content: PropTypes.object,
        };
        render() {
            return <div />;
        }
    },
);

export { Right };
export default Right;
